(function () {
  'use strict';
  if (window.PGSocialProofAgeCapV104) return;
  window.PGSocialProofAgeCapV104 = true;
  function cap(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = [];
    if (root.matches && root.matches('.pg-social-proof-card__meta')) nodes.push(root);
    root.querySelectorAll('.pg-social-proof-card__meta').forEach(function (el) { nodes.push(el); });
    nodes.forEach(function (el) {
      var match = String(el.textContent || '').trim().match(/^(\d+)\s+days?\s+ago$/i);
      if (match && Number(match[1]) > 2) el.textContent = '2 days ago';
    });
  }
  function start() {
    cap(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (node.nodeType === 1) cap(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
